import React from 'react';
import locales from '../../../../../content.json';
import s from './index.module.scss';
import { useDigitalProductPrice } from './useDigitalProductPrice';

export const Price = () => {
  const { price, oldPrice, currency } = useDigitalProductPrice();

  return (
    <div className={s.wrapper}>
      <p className={s.text}>{locales[window.userLang].pdfUpselling_13}</p>
      <div className={`${s.price} ${currency === 'USD ' ? s.USD : ''}`}>
        <p>-54%</p>
        <p>{currency}{oldPrice}</p>
        <p>{currency}{price}</p>
      </div>
    </div>
  );
};
